import _ from "lodash";
import {
  UserAuthModel,
  UserMemo,
  SalesManagerService,
} from "../../services/index";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { UserModel, UserService, AlertService } from "../../services/index";
import { FileUploader } from "ng2-file-upload";
import { REST_API_REQUEST_CALL_URL } from "../../utils/rest-api-request-url";
import { Util } from "../../utils";
import { SalesManager } from "app/services/sales/model/SalesManager";
import { PutUserSalesManagerParam } from "app/services/sales/model/PutUserSalesManagerParam";
import { isNumber } from "angular-pipes/src/utils/utils";
import { ApiService } from "app/services/api.service";
declare var $: any;

@Component({
  selector: "user-info",
  templateUrl: "user-info.component.html",
})
export class UserInfoCompoent {
  userInfo: UserModel = new UserModel();
  userSaleManager: SalesManager = new SalesManager();
  userInfoPre: UserModel = new UserModel();

  @Input() set userData(userModel: UserModel) {
    if (!userModel) return;
    this.userInfo = _.clone(userModel);
    if (
      (this.userInfo.jobTp === "0" && this.userInfo.userAuthList == null) ||
      _.isEmpty(this.userInfo.userAuthList) ||
      this.userInfo.userAuthList.length <= 0
    ) {
      let userAuth = new UserAuthModel();
      userAuth.authTypeCd = 0;
      userAuth.stusCd = 0;

      this.userInfo.userAuthList = new Array();
      this.userInfo.userAuthList.push(userAuth);

      if (this.userInfo.salesManager) {
        this.userSaleManager = this.userInfo.salesManager;
      }
    }

    for (let key in this.userInfo) {
      this.userInfoPre[key] = _.cloneDeep(this.userInfo[key]);
    }

    // if(this.userInfo.userId) {
    //   this.userService.getUserMemo(this.userInfo.userId).subscribe(resp => {
    //     this.userMemo = resp.memo;
    //     this.userMemoResult = resp;
    //   })
    // }
  }

  @Output() closeEmit: EventEmitter<any> = new EventEmitter();
  @Output() refreshDetailEmit: EventEmitter<any> = new EventEmitter();
  apiUrl: string = REST_API_REQUEST_CALL_URL.BASE_URL;

  pwd: string;
  pwdConfirm: string;
  uploader: FileUploader = new FileUploader({});

  @ViewChild("fileInput")
  fileInput: ElementRef;

  userMemoResult: UserMemo = new UserMemo();

  userMemo: string;

  getLocaleTime: Function = Util.getLocaleTime;

  salesManagers: SalesManager[] = [];

  finalUploadFile;

  fileName = "";
  regFileName = "";
  reqStatus = "";
  originStatus = null;
  originCorpRegNo = null;
  isUpdated = false;
  userAuthId = null;

  constructor(
    private userService: UserService,
    private alertService: AlertService,
    private salseManagerService: SalesManagerService,
    private apiService: ApiService
  ) {
    this.salseManagerService.getSalesManagers((sms) => {
      for (const sm of sms) {
        this.salesManagers.push(new SalesManager(sm));
      }
    });
  }

  ngOnInit(): void {
    // stusCd == 2 사용 중단으로 인해 stusCd가 2인 경우 3으로 처리 (2021.10.27)
    this.userInfo.userAuthList[0].stusCd =
      this.userInfo.userAuthList[0].stusCd == 2
        ? 3
        : this.userInfo.userAuthList[0].stusCd;

    this.originStatus = this.userInfo.userAuthList[0].stusCd;
    this.originCorpRegNo = this.userInfo.userAuthList[0].corpRegNo;

    // this.userInfo.userId
    this.userService.getCorpReg(this.userInfo.userId).subscribe((resp) => {
      if (resp) {
        this.userInfo.userAuthList[0].corpRegNo = resp.corpRegNo;
        this.regFileName = resp.corpRegFileNm;
        this.fileName = resp.tempCorpRegFileNm;
        this.userAuthId = resp.userAuthId;
      }
    });
  }

  close(isSearch: boolean) {
    this.closeEmit.emit(isSearch);
  }

  fileDownload(type: string) {
    this.apiService.getToken((res) => {
      const access_token = sessionStorage.getItem("_vcd");

      if (access_token) {
        let hrefUrl;
        if (type == "registered") {
          hrefUrl = `${REST_API_REQUEST_CALL_URL.BASE_URL}user/v2/admin/auth/corp-reg-file?token=${access_token}&user-id=${this.userInfo.userId}`;
        } else {
          hrefUrl = `${REST_API_REQUEST_CALL_URL.BASE_URL}user/v2/admin/auth/corp-reg-file/temp?token=${access_token}&user-id=${this.userInfo.userId}`;
        }
        var link = document.createElement("a");
        link.download = hrefUrl;
        link.href = hrefUrl;
        link.click();
      }
    });
  }

  postUserinfo() {
    if (!this.userInfo) return;

    if (!this.userInfo.userId) {
      if (this.pwd != this.pwdConfirm) {
        this.alertService.error("비밀번호와 비밀번호 확인이 다릅니다.");
        return false;
      }
    }

    if (!this.userInfo.userTp && this.userInfo.userTp !== "0") {
      this.alertService.error("사용자 구분을 선택하세요");
      return false;
    }

    if (
      this.userInfo.userTp !== "0" &&
      !this.userInfo.jobTp &&
      this.userInfo.jobTp !== "0"
    ) {
      this.alertService.error("직업 구분을 선택하세요");
      return false;
    }

    if (!this.userInfo.stusCd && this.userInfo.stusCd !== 0) {
      this.alertService.error("가입 구분을 선택하세요");
      return false;
    }

    if (
      this.userInfo.lastNm == null ||
      this.userInfo.lastNm == undefined ||
      this.userInfo.lastNm.length < 1
    ) {
      this.alertService.error("성명 중 성을 입력해주세요.");
      return false;
    }

    if (
      this.userInfo.firstNm == null ||
      this.userInfo.firstNm == undefined ||
      this.userInfo.firstNm.length < 1
    ) {
      this.alertService.error("성명 중 명을 입력해주세요.");
      return false;
    }

    this.userInfo.password = this.pwd;
    this.userService.postUserInfo(this.userInfo).subscribe((resp) => {
      if (resp.result) {
        this.close(true);
        if (!this.userInfo.userId) {
          this.alertService.success("회원 가입이 완료되었습니다.");
        }
      }
    });
  }

  patchUserinfo() {
    let changedUserInfo = {};
    for (let key in this.userInfo) {
      if (
        key != "userMemoList" &&
        key != "usetAuthList" &&
        this.userInfo[key] != this.userInfoPre[key]
      ) {
        changedUserInfo[key] = this.userInfo[key];
      }
    }

    if (_.isEmpty(changedUserInfo)) {
      this.alertService.error("변경된사항이 없습니다.");
      return;
    }

    this.userService.patchUserInfo(
      this.userInfo.userId,
      changedUserInfo,
      (resp) => {
        if (!_.isEmpty(resp)) {
          for (let key in resp) {
            this.userInfo[key] = resp[key];
          }
          this.closeEmit.emit(this.userInfo);
          this.alertService.success("회원정보 수정이 완료되었습니다.");
        }
      }
    );
  }

  jobTpChange() {
    if (this.userInfo.jobTp != "99") {
      this.userInfo.jobTxt = "";
    }
  }

  refreshDetail(userId: number) {
    this.refreshDetailEmit.emit(userId);
  }

  uploadRegFile(e) {
    if (this.userInfo.userId != null) {
      this.userService.postCorpReg(this.userInfo.userId, this.uploader);
      this.uploader.onCompleteItem = (
        item: any,
        response: any,
        status: any,
        headers: any
      ) => {
        var responsePath = JSON.parse(response);
        this.refreshDetail(this.userInfo.userId);
        $.sweetModal({
          content: "저장되었습니다.",
          icon: $.sweetModal.ICON_SUCCESS,
        });
      };
      this.uploader.onErrorItem = (
        item: any,
        response: any,
        status: any,
        headers: any
      ) => {
        var responsePath = JSON.parse(response);
        this.refreshDetail(this.userInfo.userId);
        $.sweetModal({
          content: responsePath.errorMsg,
          icon: $.sweetModal.ICON_WARNING,
        });
      };
    }
  }

  fileUpload() {
    if (
      this.userInfo == null ||
      this.userInfo.userId == null ||
      this.userInfo.userId < 0
    ) {
      $.sweetModal({
        content: "저장을 완료한 후 파일을 등록해주세요.",
        icon: $.sweetModal.ICON_WARNING,
      });
      return;
    }

    this.fileInput.nativeElement.click();
  }

  changeFindRouteAuth(value: number) {
    if (this.userInfo.jobTp != "0") {
      $.sweetModal({
        content: "화주만 경로찾기 권한의 상태값을 변경 할 수 있습니다.",
        icon: $.sweetModal.ICON_WARNING,
      });
      return;
    }
    let targetAuth: UserAuthModel = this.userInfo.userAuthList[0];

    // if(this.userInfo.userAuthList.length <= 0){
    //   targetAuth = new UserAuthModel();
    //   targetAuth.authTypeCd = 0;
    // }else{
    //   targetAuth = this.userInfo.userAuthList[0];
    // }
    console.log(value);
    targetAuth.stusCd = value;
  }

  handleClickSaveAuth() {
    if (!_.isEmpty(this.userInfo.userAuthList[0])) {
      this.userService.patchUserAuth(
        this.userInfo.userAuthList[0].userAuthId,
        this.userInfo.userAuthList[0],
        (resp) => {
          if (resp && resp["error"] != undefined) {
            this.alertService.error("에러가 발생했습니다. 다시 시도해 주세요.");
          } else {
            this.alertService.success("저장되었습니다.");
            this.userInfo.userAuthList[0] = resp;
          }
        }
      );
    }
  }

  onSalesManagerChange(event) {
    const userId: number = Number(this.userInfo.userId);
    const salesManagerUserId: number = Number(event.target.value);
    const salesmanager = this.salesManagers.find(
      (value) => value.userId === salesManagerUserId
    );
    this.userInfo.salesManager = salesmanager;

    const completeCallback = () => {
      this.alertService.success("영업담당자가 변경되었습니다.");
      this.closeEmit.emit(this.userInfo);
    };

    if (
      userId &&
      isNumber(userId) &&
      salesManagerUserId &&
      isNumber(salesManagerUserId)
    ) {
      const param: PutUserSalesManagerParam = new PutUserSalesManagerParam(
        userId,
        salesManagerUserId
      );
      this.salseManagerService.putSalesManagers(
        param,
        (error) => this.alertService.error(error),
        completeCallback
      );
    }
  }

  updateCorRegInfo() {
    const stusCd = this.userInfo.userAuthList[0].stusCd;
    const corpRegNo = this.userInfo.userAuthList[0].corpRegNo;

    let reqBody: any = {};

    if (this.originStatus !== stusCd) {
      this.isUpdated = true;
      reqBody = { ...reqBody, stusCd };
    }

    if (this.originCorpRegNo !== corpRegNo) {
      this.isUpdated = true;
      reqBody = { ...reqBody, corpRegNo };
    }

    if (this.isUpdated) {
      return this.userService
        .patchUpdateStatus(this.userAuthId, reqBody)
        .subscribe((resp) => {
          if (resp) {
            this.close(false);
            this.isUpdated = false;
          }
        });
    }

    if (!this.reqStatus) {
      return;
    } else {
      this.userService
        .postUpdateCorpReg(this.reqStatus, this.userInfo.userId)
        .subscribe((resp) => {
          if (resp) {
            this.close(false);
          }
        });
    }
  }

  removeFile() {
    if (this.fileName) {
      this.fileName = "";
      this.finalUploadFile = null;
      this.reqStatus = "refuse";
    }
  }

  updateFile() {
    if (this.fileName) {
      this.regFileName = this.fileName;
      this.reqStatus = "approve";
    }
  }

  uploadPicFile(fileInput: any) {
    let reader = new FileReader();

    // uploader.queue[0]?.file?.name
    console.log(fileInput);

    if (fileInput && fileInput.target.files && fileInput.target.files.length) {
      const [file] = fileInput.target.files;
      reader.readAsDataURL(file);
      // this.showModal = true;
      const files = fileInput.target.files[0];
      if (!!files) {
        this.finalUploadFile = files;
        // this.uploadFileForm.get("file").setValue(files);
        this.fileName = files.name;
        console.log(this.fileName);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user/user-info.component.ts